<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{ entityUsageData.title }}</h2>
  </div>
  <div class="cald_content">
    @if (entityUsageData.infoMessage) {
      <div class="alert alert-info">
        <span class="sap-icon">&#xe202;</span>
        <div class="content">
          {{ entityUsageData.infoMessage }}
        </div>
      </div>
    }
    <h2 class="cald-heading">{{ entityUsageData.contentTitle }}</h2>
    @for (objectUsage of entityUsageData.entityUsages; track objectUsage) {
      <ul class="main-list">
        @if (objectUsage.relatedEntityType && (!objectUsage.relatedEntitiesExtended || objectUsage.relatedEntitiesExtended.length === 0)) {
          <li class="item-header">{{ objectUsage.relatedEntityType }}</li>
          @if (objectUsage.relatedEntities.length) {
            @for (usedIn of objectUsage.relatedEntities; track usedIn) {
              <li style="display: flex;">
                {{ usedIn }}
              </li>
            }
          } @else {
            <li class="centered">{{ 'Msg.NotUsed' | translate }}</li>
          }
        } @else {
          <li class="item-header multicolumn-row">
            @for (extendedUsedInInfo of objectUsage.relatedEntitiesExtended[0]; track extendedUsedInInfo) {
              <div class="table-header">
                {{ extendedUsedInInfo.key }}
              </div>
            }
          </li>
          @if (objectUsage.relatedEntitiesExtended.length) {
            @for (extendedUsedInInfoSet of objectUsage.relatedEntitiesExtended; track extendedUsedInInfoSet) {
              <li class="multicolumn-row">
                @for (extendedUsedInInfo of extendedUsedInInfoSet; track extendedUsedInInfo) {
                  <div class="table-cell">
                    {{ extendedUsedInInfo.value }}
                  </div>
                }
              </li>
            }
          } @else {
            <li class="centered">{{ 'Msg.NotUsed' | translate }}</li>
          }
        }
      </ul>
    }
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>


